<template>
    <b-card body-class="d-flex flex-column justify-content-between">
        <div class="d-flex flex-column align-items-center justify-content-between border rounded">
            <div class="d-flex justify-content-center">
                <div class="links-img">
                    <img src="@/assets/images/pages/link.png" class="w-100 h-100">
                </div>
            </div>
            <div class="text-center" style="margin-top: -26px;margin-bottom: 24px;">
                <b-button @click="$bvModal.show('get-links')" class="w-100 px-1" variant="flat-primary">
                    لینک ها و QR کد مجموعه
                </b-button>
            </div>
        </div>

        <!--------------------- modal --------------------->
        <b-modal id="get-links" title=" لینک ها و QR کد مجموعه" size="md" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <div v-if="!loading">
                <div v-if="!managerInformationConfirmed" class="px-50 py-1">
                    <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                        <span>برای دسترسی به این قسمت، لطفا</span>
                        <router-link class="mx-25" to="/identity-management">هویت</router-link>
                        <span>خود را تایید کنید.</span>
                    </div>
                </div>
                <div v-else class="px-50 py-1">
                    <div class="mb-1">
                        <div class="d-flex flex-column align-items-center justify-content-between mb-1">
                            <div>لینک دامنه ir. مجموعه </div>
                            <a :href="`https://menutech.ir/profile/${urlName}`" target="_blank">{{
                                `menutech.ir/profile/${urlName}` }}</a>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-between mb-1">
                            <div> لینک دامنه com. مجموعه</div>
                            <a :href="`https://menutechx.com/profile/${urlName}`" target="_blank">{{
                                `menutechx.com/profile/${urlName}` }}</a>
                        </div>
                    </div>
                    <p class="pt-1">
                        - لینک ها در این صفحه، صرفا برای نمایش در شبکه های اجتماعی و یا ارسال برای مشتریان مجموعه است.
                        برای دریافت لینک مخصوص هر میز، با ما در ارتباط باشید.
                    </p>
                    <hr class="mb-2 pb-50 mt-2">
                    <div class="d-flex justify-content-center mb-2 pb-50 mt-1">
                        <vue-qr-code :text="`https://menutechx.com/profile/${urlName}`" error-level="L" :size="200">
                        </vue-qr-code>
                    </div>
                    <p>
                        - QR کد در این صفحه، صرفا برای نمایش است. برای دریافت QR کد مخصوص هر میز و همچنین دریافت فایل QR
                        کد معمولی رایگان و یا QR کد حرفه ای رایگان (با لوگو شخصی مجموعه)، با ما در ارتباط باشید.
                    </p>
                    <hr class="my-2">
                    <h5 class="mt-2">راه های ارتباطی</h5>
                    <div class="d-flex align-items-center h5 mb-1 mt-2">
                        <span class="mr-50">تلگرام : </span>
                        <a href="https://t.me/menutech_support" class="font-weight-bolder"
                            target="_blank">menutech_support@</a>
                    </div>
                    <div class="d-flex align-items-center h5">
                        <span class="mr-50">تیکت : </span>
                        <router-link to="/tickets" class="font-weight-bolder">ثبت تیکت</router-link>
                    </div>
                </div>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BButton, BRow, BCol } from 'bootstrap-vue';
export default {
    name: 'links',
    components: {
        BCard,
        BButton,
        BRow,
        BCol
    },
    data() {
        return {
            loading: true,
            urlName: null,
            managerInformationConfirmed: false
        }
    },
    mounted() {
        this.urlName = localStorage.getItem("urlName")
        if (this.urlName && this.urlName != 'null') {
            this.managerInformationConfirmed = true
        }
        this.loading = false
    }
}
</script>

<style lang="scss">
.links-img {
    width: 180px;

    @media (max-width: 767px) {
        width: 220px;
    }
}

.qr-code-img {
    width: 180px;

    @media (max-width: 767px) {
        width: 220px;
    }
}
</style>